import { RootState } from '../store';

export const getEmailSubscriptions = (state: RootState) => state.emailSubscription.subscriptions;
export const getEmailSubscriptionsQuery = (state: RootState) => state.emailSubscription.query;
export const getIsLoadingEmailSubscriptions = (state: RootState) => state.emailSubscription.isLoading;
export const getEmailSubscriptionsError = (state: RootState) => state.emailSubscription.error;
export const getIsSendingEmail = (state: RootState) => state.emailSubscription.isSending;
export const getSendEmailError = (state: RootState) => state.emailSubscription.sendError;
export const getSendEmailSuccess = (state: RootState) => state.emailSubscription.sendSuccess;
export const getIsActivatingSubscription = (state: RootState) => state.emailSubscription.isActivating;
export const getActivateError = (state: RootState) => state.emailSubscription.activateError;
export const getActivateSuccess = (state: RootState) => state.emailSubscription.activateSuccess;
